export default {
    header: {
        self: {},
        items: [
        ]
    },
    aside: {
        self: {},
        items: [
            {
                title: 'Partner',
                root: true,
                icon: 'flaticon2-layers-1',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Transacciones',
                        page: 'partner',
                        // icon: "flaticon2-line-chart"
                    }, {
                        title: 'Vouchers',
                        page: 'vouchers',
                        // icon: "flaticon2-paper"
                    }
                ]
            },
            {
                title: 'Clientes',
                root: true,
                icon: 'flaticon2-group',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Listado de clientes',
                        desc: 'Lista de todos los clientes',
                        page: 'clients',
                        // icon: "flaticon2-group"
                    },
                    {
                        title: 'Altas Cuentas',
                        desc: 'Lista de todas las cuentas',
                        page: 'accounts',
                        // icon: "flaticon2-soft-icons-1"
                    },
                    {
                        title: 'Alta Productos',
                        desc: 'Listado de Productos',
                        page: 'products',
                        // icon: "flaticon2-open-box"
                    },
                    {
                        title: 'Reclamos',
                        desc: 'Listado de Reclamos',
                        page: 'comments',
                        // icon: "flaticon2-paper"
                    },
                    {
                        title: 'Bajas',
                        desc: 'Listado de Bajas',
                        page: 'cancelations',
                        // icon: "flaticon2-paper"
                    }
                ]
            },
            {
                title: 'Finket / Proveedores',
                root: true,
                icon: 'flaticon2-soft-icons-1',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Saldos Actuales',
                        desc: 'Lista de todas las cuentas Actuales',
                        page: 'accounts/operative',
                        // icon: "flaticon2-soft-icons-1"
                    },
                    {
                        title: 'Cuentas Owns',
                        desc: 'Lista de todas las cuentas own',
                        page: 'own',
                        // icon: "flaticon2-soft-icons-1"
                    },
                    {
                        title: 'Cuentas Proveedores',
                        desc: 'Proveedores',
                        page: 'suppliers',
                        // icon: "flaticon2-contract"
                    },
                    {
                        title: 'Listado de Usuarios',
                        desc: 'Lista de todos los usuarios',
                        page: 'users',
                        // icon: "flaticon2-user-1"
                    },

                ]
            },
            {
                title: 'Operaciones',
                root: true,
                icon: 'flaticon2-line-chart',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Transacciones',
                        desc: 'Lista de todas las Transacciones',
                        page: 'transactions',
                        // icon: "flaticon2-line-chart"
                    },
                    {
                        title: 'Ajuste Manual',
                        desc: 'Ajuste Manual',
                        page: 'adjustments',
                        // icon: "flaticon2-dashboard"
                    },
                    {
                        title: 'Notificaciones',
                        desc: 'Notificaciones',
                        page: 'notifications',
                        // icon: "flaticon2-notification"
                    }
                ]
            },
            {
                title: 'Gestión',
                root: true,
                icon: 'flaticon2-dashboard',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Pricing',
                        desc: 'Pricing',
                        page: 'pricing',
                        // icon: "flaticon2-checking"
                    },
                    {
                        title: 'Checker',
                        desc: 'Checker',
                        page: 'checker',
                        // icon: "flaticon2-check-mark"
                    }
                ]
            },
            {
                title: 'Monitoreo',
                root: true,
                icon: 'flaticon2-protected',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'Health Microservicios',
                        desc: 'Listado de Health',
                        root: true,
                        page: 'health',
                        // icon: "flaticon2-heart-rate-monitor"
                    },
                ]
            },
            {
                title: 'Reportes',
                root: true,
                icon: 'flaticon2-paper',
                bullet: 'dot',
                submenu: [
                    {
                        title: 'BCRA',
                        desc: 'Reportes para el Banco Central',
                        root: true,
                        page: 'reports/bcra',
                        // icon: "la la-institution"
                    },
                    {
                        title: 'Asientos contables',
                        desc: 'Registro asientos contables diarios',
                        root: true,
                        page: 'reports/records',
                        // icon: "la la-institution"
                    },
                ]
            }
        ]
    }
};
